module.exports = __webpack_public_path__ + "static/media/sobre_2.dca9f70d.jpg";